import fvllLogo from "../images/fvll.jpg"
import rcrLogo from "../images/Rose_City_Rollers_logo_2018.png"

export const volunteering = [
    {
        organization: "Fort Vancouver Little League",
        logo: fvllLogo,
        roles : [
            {
                title: "Scorekeeper",
                start: "2022",
                end: "Current",
            },
            {
                title: "Concession Volunteer",
                start: "2022",
                end: "Current",
            },
            {
                title: "Concession Co-Manager",
                start: "2025",
            },
        ]
    },
    {
        organization: "Rose City Rollers",
        logo: rcrLogo,
        roles: [
            {
                title: "Juniors Schedule Wrangler",
                start: "2024",
                end: "Current",
            },
            {
                title: "Skating Official",
                start: "2025",
                end: "Current",
            },
            {
                title: "Non-Skating Official",
                start: "2025",
                end: "Current",
            }
        ]
    },
]